import { Injectable } from '@angular/core';

import { Observable, filter, map } from 'rxjs';

import {
  WebsocketClient,
  WebsocketFactory,
  socketUrls,
} from '@personal-area/global/websocket';

import { CountryChangeStatus } from '../models/status';
import { CountryChangeStatusRequestEvent, WebsocketEventType, WebsocketEvent } from '../models/websocket.events';

@Injectable()
export class CountryChangeSocketService {
  private _client: WebsocketClient;

  constructor(private readonly _factory: WebsocketFactory) {}

  public connect() {
    this._client = this._factory.create(socketUrls.base, 'user')
      .useAuth();

    this._client.init();
  }

  public get userCountryStatusChanged(): Observable<CountryChangeStatus> {
    return this._client
      .output<{ result: WebsocketEvent<CountryChangeStatusRequestEvent> }>()
      .pipe(
        filter(
          (event) =>
            event.result.eventType ===
            WebsocketEventType.UserCountryStatusChanged,
        ),
        map((event) => {
          const response = event.result.response.countryRequest;
          return {
            status: response.status,
            requestedCountry: response.newCountry,
            currentCountry: response.oldCountry,
          };
        }),
      );
  }
}
